import { DirectusItemWrapper, DirectusPositionItems } from 'config';
import { IPosition } from '../../..';

export const mapDirectusInitialPositionItems = (position?: DirectusItemWrapper<DirectusPositionItems>[]): IPosition => ({
  x: position?.length ? position[0].item.X : 5,
  y: position?.length ? position[0].item.Y : 5,
});
